import React, { useState, useEffect } from "react";

// selected: true when this card represents the page currently being viewed. Uses the exact
// same submenu-card/submenu-card-selected classes DataTable.js's own SubMenuCM renders with
// (Shared/App.css) — not a copy of that styling, the same classes — so any future change to
// Compliance Manager's own submenu hover/selected/sizing/etc. applies here too.
//
// Renders just the <a> card itself, not its own .submenu-grid wrapper — SubMenuCM renders
// all of its cards as direct siblings inside one shared .submenu-grid, and this needs to sit
// alongside OpenSubmissionsKpiCard.js the same way (see DataTable.js's call sites), not each
// wrapped in its own separate grid nested inside an extra flex container.
const SubmissionQAKpiCard = ({ selected = false }) => {

    const [count, setCount] = useState(null);

    let currentLegalManufacturerFilter = window.legalManufacturerId;
    useEffect(() => {
        fetch('/umbraco/api/SubmissionQAList/QACount/?legalManufacturerId=' + currentLegalManufacturerFilter)
            .then((response) => response.ok ? response.json() : null)
            .then((data) => setCount(data))
            .catch((error) => console.log("error: " + error));
    }, []);

    return (
        <a href="/your-medboard/country-registrations/submissionsqa/" className={`submenu-card qa-kpi-card ${selected ? "submenu-card-selected" : ""}`}>
            <span className="submenu-title">Submissions Q&amp;A</span>
            <div className="submenu-value-row">
                <i className="fas fa-question-circle submenu-icon"></i>
                <span className="submenu-value" style={{ color: "rgb(85, 85, 85)" }}>{count ?? "…"}</span>
            </div>
        </a>
    );
};

export default SubmissionQAKpiCard;
